export default __webpack_public_path__ + "static/media/loading_page_bg.fedc41f0.png";